import { useSyncExternalStore } from 'react';
import { nothing } from 'immer';
import createStore from './store';
import { MetadataMap } from '@/player-config/src/types/RemotionPlayerConfigTypes/Metadata/MetadataMap';
import { VolumeProps } from '@/player-config/src/types/RemotionPlayerConfigTypes/Metadata/VolumeProps';

export type DefinedVolumePreviewStoreType = MetadataMap<VolumeProps, VolumeProps>;

type VolumePreviewStoreType = DefinedVolumePreviewStoreType | undefined;

const volumePreviewStore = createStore<VolumePreviewStoreType>(undefined);

export const updatePreviewVolume = (newState: DefinedVolumePreviewStoreType) => {
  volumePreviewStore.update(draft => {
    if (!draft) {
      return { ...newState };
    }
    Object.assign(draft, newState);
  });
};

export const clearPreviewVolume = () => {
  return volumePreviewStore.set(() => nothing);
};

export const usePreviewVolumeStore = () => {
  return useSyncExternalStore(volumePreviewStore.subscribe, volumePreviewStore.getSnapshot);
};
